import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
// To avoid exposing your Firebase credentials in your code:
// 1. Create a .env file in the root of your project
// 2. Add your Firebase configuration values there like this:
//    REACT_APP_FIREBASE_API_KEY=your_api_key
//    REACT_APP_FIREBASE_AUTH_DOMAIN=your_auth_domain
//    REACT_APP_FIREBASE_PROJECT_ID=your_project_id
//    REACT_APP_FIREBASE_STORAGE_BUCKET=your_storage_bucket
//    REACT_APP_FIREBASE_MESSAGING_SENDER_ID=your_messaging_sender_id
//    REACT_APP_FIREBASE_APP_ID=your_app_id

const firebaseConfig = {
  // Use environment variables with fallbacks for development only
  // IMPORTANT: For production, always properly configure your .env file
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDemoKeYfOrDevelopmentOnly123456",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "demo-project.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "demo-project",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "demo-project.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789012",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:123456789012:web:abcdef123456789012"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Authentication
const auth = getAuth(app);

export { db, auth }; 